import { InjectionToken } from '@angular/core';

export const BAZIS_IS_MOBILE = new InjectionToken<boolean>('BAZIS_IS_MOBILE', {
    providedIn: 'root',
    factory: () => {
        const userAgent = navigator.userAgent;

        return /android|iphone|ipad|ipod|opera mini|iemobile|blackberry|mobile/i.test(userAgent);
    },
});
